import React from "react";
import { Spinner } from "reactstrap";
import { Pagination } from "components/Pagination";
import { CompanyCard } from "./CompanyCard";

interface CompanyListProps {
    companies: Array<{
        id: string;
        name: string;
        description?: string;
        logo?: string;
        sector?: string;
        location?: string;
        jobCount?: number;
    }>;
    isLoading?: boolean;
    error?: any;
    totalCount?: number;
    itemsPerPage?: number;
    currentPage?: number;
    onPageChange?: (page: number) => void;
    emptyMessage?: string;
    showPagination?: boolean;
}

export const CompanyList = ({
    companies,
    isLoading = false,
    error,
    totalCount = 0,
    itemsPerPage = 12,
    currentPage = 1,
    onPageChange,
    emptyMessage = "No companies found",
    showPagination = true
}: CompanyListProps) => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);

    if (isLoading) {
        return (
            <div className="oec-section-inner oec-jobs-status">
                <Spinner color="primary" />
                <p>Loading companies...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="oec-section-inner oec-jobs-status">
                <p>Error loading companies. Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="oec-section-inner">
            <div className="oec-jobs-results">
                <h2>{totalCount} {totalCount === 1 ? "Company" : "Companies"} Found</h2>
                {totalCount > itemsPerPage && (
                    <span>Page {currentPage} of {totalPages}</span>
                )}
            </div>

            {companies.length > 0 ? (
                <div className="oec-card-grid oec-card-grid-roomy">
                    {companies.map((company) => (
                        <CompanyCard key={company.id} company={company} />
                    ))}
                </div>
            ) : (
                <div className="oec-jobs-status">
                    <h3>{emptyMessage}</h3>
                    <p>Try a different keyword.</p>
                </div>
            )}

            {showPagination && onPageChange && totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </div>
    );
};
